export default __webpack_public_path__ + "static/media/body-therapy-icon2.bda854a7.svg";